<template>
    <div class="contracts-list"></div>
</template>

<script>
export default {
  name: 'ContractsList',
}
</script>
